import { Directive, HostBinding, Optional, Input } from '@angular/core';
import { ControlContainer} from '@angular/forms';

@Directive({
    selector: 'label[controlName]',
    standalone: false
})
export class LabelControl {
  @Input() controlName: string;

  constructor(@Optional() private parent: ControlContainer) {}

  @HostBinding('textContent')
  get controlValue() {

    let control: any;
    let retVal: any;

    if (this.parent) {

      control = this.parent?.control?.get(this.controlName);

      if (control) {

        retVal = control.value;
      } else {

        retVal = '';
      }
    } else {

      retVal = '';
    }

    return retVal;
  }
}
